module.exports = __webpack_public_path__ + "static/img/paytypenor_20x20_@3x.6bd3adb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paytypenor_20x20_@3x.png
// module id = 6qxZ
// module chunks = 1